import { useDebouncedEffect } from '@/fsd/shared/model/hooks/useDebouncedEffect';
import { useRef } from 'react';
import { validateEmail } from '../../lib/helpers/validateEmail'; // Use the newly created validateEmail

const DEBOUNCE_TIME = 1000;

interface DebouncedEmailValidateProps {
  email: string;
  setFormErrors: React.Dispatch<React.SetStateAction<any>>; // More specific type if possible
}

export const useDebouncedEmailValidate = ({
  email,
  setFormErrors,
}: DebouncedEmailValidateProps) => {
  const isFirst = useRef(true);

  useDebouncedEffect(
    () => {
      if (!isFirst.current) {
        const emailError = validateEmail(email);
        setFormErrors((prev) => ({
          ...prev,
          email: emailError || '',
        }));
      } else {
        isFirst.current = false;
      }
    },
    [email],
    DEBOUNCE_TIME
  );
};
